import { useDispatch, useSelector } from 'react-redux';
import { nameTableColumn, nameTableRows } from '../constants/nameTableRso';
import { setValueForm } from '../store/actions/rsoImportActions';
import useReportRsoMutation from '../../../mutations/useReportRsoMutation';
import { getColumnsAddress } from '../utils/getColumnsAddress';

const useClickCreateRso = (form) => {
  const { validateFields } = form;

  const { file, columnLabels } = useSelector((state) => state.rsoImportStore);

  const dispatch = useDispatch();

  const { createRso } = useReportRsoMutation();

  const onClickBtn = (e) => {
    e.preventDefault();
    const formData = new FormData();
    formData.append('excelFile', file);

    validateFields(async (err, values) => {
      if (err) return;

      dispatch(setValueForm(values));

      await createRso({
        requestReportRSO: {
          ServiceCompanyId: values?.[nameTableColumn.serviceCompanyId],
          HeaderRow: values?.[nameTableRows.headerRow],
          FirstRow: values?.[nameTableRows.firstRow],
          ColumnSerialNumber: values?.[nameTableColumn.columnSerialNumber],
          ColumnMeterReading: values?.[nameTableColumn.columnMeterReading],
          ColumnDate: values?.[nameTableColumn.columnDate],
          ColumnTariff: values?.[nameTableColumn.columnTariff],
          ColumnsAddress: getColumnsAddress(values, columnLabels),
          MeterTriffs:
            values?.[nameTableColumn.MeterTriffs_One] &&
            values?.[nameTableColumn.MeterTriffs_Two]
              ? [
                  values?.[nameTableColumn.MeterTriffs_One],
                  values?.[nameTableColumn.MeterTriffs_Two],
                ]
              : undefined,
        },
        excelFile: formData,
      });
    });
  };

  return onClickBtn;
};

export default useClickCreateRso;
